import { render, staticRenderFns } from "./recommendationsPage.vue?vue&type=template&id=626171d0&scoped=true&"
import script from "./recommendationsPage.vue?vue&type=script&lang=js&"
export * from "./recommendationsPage.vue?vue&type=script&lang=js&"
import style0 from "./recommendationsPage.vue?vue&type=style&index=0&id=626171d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626171d0",
  null
  
)

export default component.exports